/**
 * FILE: apps/hub/src/lib/utils.ts
 * PURPOSE: Utility / configuration module.
 * AGENT_CONTEXT: Shared logic. Keep pure when possible. Export from index if public.
 * LAST_REVIEWED: 2026-05-07
 */

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
